export default __webpack_public_path__ + "static/media/american.419dd72d.svg";